module.exports = __webpack_public_path__ + "static/img/bg_sales.58f4465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_sales.png
// module id = 597f
// module chunks = 192